module.exports = __webpack_public_path__ + "img/fstbg.aacc5e61.png";